import { ClosedCaptionOutlineIcon } from './ClosedCaptionOutlineIcon';

/**
 * author: Google
 * id 08F32D33-77C4-4FEB-AAF6-04468AF0875F
 * name closed-caption-outline
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/closed-caption-outline.svg
 * tags
 */
export const CcOutlineIcon = ClosedCaptionOutlineIcon;
export default CcOutlineIcon